<template>
  <div class="client" style="padding: 10px; margin-top: 10px">
    <header>
      <h2 style="font-size: 1.5em">{{ $t('client.title') }}</h2>
      <a-space>
        <a-button
          v-if="auth.find(a => a.code === 'auth:client:query')"
          type="primary"
          @click="handleSearch"
        >{{ $t('buttons.search') }}</a-button>
        <a-button
          v-if="auth.find(a => a.code === 'auth:client:insert')"
          type="primary"
          @click="visible=true; title=$t('client.addTitle')"
        >{{ $t('buttons.add') }}</a-button>
        <!--  @click="visible=true" -->
        <!-- @click="$router.push({ path: '/customer/detail' })" -->
      </a-space>
    </header>
    <el-table
      :data="list"
      stripe
      style="width: 100%"
      :header-cell-style="{ backgroundColor: '#fafafa' }"
      v-loading="isLoading"
    >
      <el-table-column prop="code" label="客户端编码">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left">
            {{ $t('client.code') }}
            <span
              @click="handleSort($event, 'code')"
              class="icons unset"
              style="cursor: pointer"
              data-index="0"
            >
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span>
          </div>
          <a-input
            @keyup.enter="handleSearch"
            allow-clear
            v-model.trim="queryParams.query[0].value"
          />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.code">{{ scope.row.code }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="客户端名称">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left">
            {{ $t('client.name') }}
            <span
              @click="handleSort($event, 'name')"
              class="icons unset"
              style="cursor: pointer"
              data-index="0"
            >
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span>
          </div>
          <a-input
            @keyup.enter="handleSearch"
            allow-clear
            v-model.trim="queryParams.query[1].value"
          />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.name">{{ scope.row.name }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="accessKey" label="accessKey" width="330">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left">
            accessKey
            <span
              @click="handleSort($event, 'accessKey')"
              class="icons unset"
              style="cursor: pointer"
              data-index="0"
            >
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span>
          </div>
          <a-input
            @keyup.enter="handleSearch"
            allow-clear
            v-model.trim="queryParams.query[2].value"
          />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.accessKey">{{ scope.row.accessKey }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="secretKey" label="secretKey" width="360">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left">
            secretKey
            <span
              @click="handleSort($event, 'secretKey')"
              class="icons unset"
              style="cursor: pointer"
              data-index="0"
            >
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span>
          </div>
          <a-input
            @keyup.enter="handleSearch"
            allow-clear
            v-model.trim="queryParams.query[3].value"
          />
        </template>
        <template slot-scope="scope">
          <text-highlight :queries="highLightInfo.secretKey">{{ scope.row.secretKey }}</text-highlight>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left">
            {{ $t('common.createdAt') }}
            <span
              @click="handleSort($event, 'createdAt')"
              class="icons unset"
              style="cursor: pointer"
              data-index="0"
            >
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间">
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left">
            {{ $t('common.updatedAt') }}
            <span
              @click="handleSort($event, 'updatedAt')"
              class="icons DESC"
              style="cursor: pointer"
              data-index="1"
            >
              <a-icon type="caret-up" />
              <a-icon type="caret-down" />
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column>
        <template #header>
          <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left">{{ $t('common.operation') }}</div>
        </template>
        <template slot-scope="scope">
          <a-button
            v-if="auth.find(a => a.code === 'auth:client:update')"
            :loading="scope.row.loading"
            @click="edit(scope.row)"
            style="padding-left: 0"
            type="link"
          >{{ $t('buttons.edit') }}</a-button>
          <a-popconfirm
            v-if="auth.find(a => a.code === 'auth:client:delete')"
            :title="$t('messages.ctrd')"
            :ok-text="$t('common.okText')"
            :cancel-text="$t('common.cancelText')"
            @confirm="removeClient(scope.row.id)"
          >
            <a href="#">{{ $t('buttons.delete') }}</a>
          </a-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <a-pagination
      style="float: right; margin-top: 20px; padding-bottom: 20px"
      :current="pagination.current"
      :total="pagination.total"
      @change="handleTableChange"
    />
    <a-modal v-model="visible" :title="title" :width="650" @ok="submitForm" @cancel="clearForm">
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 19 }"
      >
        <a-form-model-item prop="code" :label="$t('client.code')">
          <a-input v-model="form.code" />
        </a-form-model-item>
        <a-form-model-item prop="name" :label="$t('client.name')">
          <a-input v-model="form.name" />
        </a-form-model-item>
        <a-form-model-item prop="stationScope" :label="$t('client.stationScope')">
          <!-- <a-select @focus="isStationShow = true" :getPopupContainer="(triggerNode) => triggerNode.parentNode" mode="tags" v-model="form.stationScope">
            <template v-if="false">
              <a-select-option v-for="station in stations" :key="station.id + ''">
                {{ station.name }}
              </a-select-option>
            </template>
          </a-select>-->
          <div data-v-1ac917c8 tabindex="-1" class="ant-select ant-select-enabled">
            <div
              role="combobox"
              aria-autocomplete="list"
              aria-haspopup="true"
              aria-controls="c38ed750-2683-4dd7-81d9-3cf691d34b3a"
              class="ant-select-selection ant-select-selection--multiple"
              @click="showStationModal"
            >
              <div class="ant-select-selection__rendered">
                <ul>
                  <li
                    v-for="(s, i) in sRes"
                    :key="s.id"
                    unselectable="on"
                    role="presentation"
                    :title="s.name"
                    class="ant-select-selection__choice"
                    style="user-select: none;"
                  >
                    <div class="ant-select-selection__choice__content">{{ s.name }}</div>
                    <span class="ant-select-selection__choice__remove" @click.stop="removeSS(i)">
                      <i
                        aria-label="图标: close"
                        class="anticon anticon-close ant-select-remove-icon"
                      >
                        <svg
                          viewBox="64 64 896 896"
                          data-icon="close"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                          focusable="false"
                          class
                        >
                          <path
                            d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
                          />
                        </svg>
                      </i>
                    </span>
                  </li>
                  <li class="ant-select-search ant-select-search--inline">
                    <div class="ant-select-search__field__wrap">
                      <input autocomplete="off" value class="ant-select-search__field" />
                      <span class="ant-select-search__field__mirror">&nbsp;</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </a-form-model-item>
        <a-form-model-item prop="authorities" :label="$t('client.authorities')">
          <!-- <a-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            mode="tags"
            v-model="form.authorities"
          >
            <a-select-option
              v-for="a in authoritiesList"
              :key="a.id"
              :value="a.id + ''"
            >{{ a['zh-CN'] }}</a-select-option>
          </a-select> -->
          <div data-v-1ac917c8 tabindex="-1" class="ant-select ant-select-enabled">
            <div
              role="combobox"
              aria-autocomplete="list"
              aria-haspopup="true"
              aria-controls="c38ed750-2683-4dd7-81d9-3cf691d34b3a"
              class="ant-select-selection ant-select-selection--multiple"
              @click="showAModal"
            >
              <div class="ant-select-selection__rendered">
                <ul>
                  <li
                    v-for="(s, i) in aRes"
                    :key="s.id"
                    unselectable="on"
                    role="presentation"
                    :title="s['zh-CN']"
                    class="ant-select-selection__choice"
                    style="user-select: none;"
                  >
                    <div class="ant-select-selection__choice__content">{{ s['zh-CN'] }}</div>
                    <span class="ant-select-selection__choice__remove" @click.stop="removeAS(i)">
                      <i
                        aria-label="图标: close"
                        class="anticon anticon-close ant-select-remove-icon"
                      >
                        <svg
                          viewBox="64 64 896 896"
                          data-icon="close"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                          focusable="false"
                          class
                        >
                          <path
                            d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
                          />
                        </svg>
                      </i>
                    </span>
                  </li>
                  <li class="ant-select-search ant-select-search--inline">
                    <div class="ant-select-search__field__wrap">
                      <input autocomplete="off" value class="ant-select-search__field" />
                      <span class="ant-select-search__field__mirror">&nbsp;</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal v-model="isStationShow" :title="$t('client.stations')" :width="1200" class="stations" @ok="confirm">
      <a-table
        :loading="isStationsLoading"
        :columns="stationsColumns"
        :data-source="stations"
        :pagination="stationPagination"
        :row-key="record => record.id + ' ' + record.name"
        :row-selection="{ selectedRowKeys: selectedStations, onChange: selectStation }"
        :scroll="{ y: 460 }"
        @change="handleStationPageChange"
      >
        <template v-slot:requiredCaptcha="text">
          {{ text ? $t('common.yes') : $t('common.no') }}
        </template>
        <template v-slot:icon="text">
          <a-icon :type="text" style="font-size: 20px" />
        </template>
        <template v-slot:enabled="text">
          {{ text ? $t('common.yes') : $t('common.no') }}
        </template>
      </a-table>
    </a-modal>
    <a-modal v-model="isAShow" :title="$t('client.authorityList')" :width="800" class="aunthorities" @ok="confirmA">
      <a-table
        :loading="isALoading"
        :columns="aColumns"
        :data-source="authoritiesList"
        :row-key="record => record.id + ' ' + record['zh-CN']"
        :row-selection="{ selectedRowKeys: selectedA, onChange: selectA }"
        :pagination="aPagination"
        @change="hanldeAPageChange"
      >
        <template v-slot:requiredCaptcha="text">
          {{ text ? $t('common.yes') : $t('common.no') }}
        </template>
        <template v-slot:icon="text">
          <a-icon :type="text" style="font-size: 20px" />
        </template>
        <template v-slot:enabled="text">
          {{ text ? $t('common.yes') : $t('common.no') }}
        </template>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import moment from "moment";
import TextHighlight from "vue-text-highlight";
import {
  searchClient,
  addClient,
  updateClient,
  getClientById,
  deleteClient
} from "@/api/auth/client";
import { searchGroupList } from "@/api/device";
import { getAuthoritiesList } from "@/api/auth/menu";

export default {
  components: {
    TextHighlight
  },
  data() {
    return {
      list: [],
      stations: [],
      isStationsLoading: false,
      isAShow: false,
      isALoading: false,
      stationsColumns: [
        {
          title: () => (<div>{ this.$t('client.stationCode') }<a-input allow-clear type="text" data-index="0" /></div>),
          dataIndex: 'code',
          key: 'code',
          scopedSlots: {
            customRender: 'code'
          },
          width: 150
        },
        {
          title: () => (<div>{ this.$t('client.stationName') }<a-input allow-clear type="text" data-index="1" /></div>),
          dataIndex: 'name',
          key: 'name',
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          title: () => (<div>{ this.$t('common.customer') }<a-input allow-clear type="text" data-index="2" /></div>),
          dataIndex: 'company',
          key: 'company',
          scopedSlots: {
            customRender: 'company'
          },
          width: 200
        },
        {
          title: () => (<div>{ this.$t('station.organization') }<a-input allow-clear type="text" data-index="3" /></div>),
          dataIndex: 'organizations',
          key: 'organizations.name',
          scopedSlots: {
            customRender: 'organizations'
          },
          width: 200
        },
        {
          title: () => this.$t('common.createdAt'),
          dataIndex: 'createdAt',
          key: 'createdAt',
          width: 160,
          scopedSlots: { customRender: 'createdAt' }
        },
        {
          title: () => this.$t('common.updatedAt'),
          dataIndex: 'updatedAt',
          key: 'updatedAt',
          width: 160,
          scopedSlots: { customRender: 'updatedAt' }
        }
      ],
      aColumns: [
        {
          title: 'id',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: () => (<div>{ this.$t('client.zh-CN') }<a-input allow-clear type="text" data-index="1" /></div>),
          dataIndex: 'zh-CN',
          key: 'zh-CN'
        },
        {
          title: () => (<div>{ this.$t('client.authCode') }<a-input allow-clear type="text" data-index="2" /></div>),
          dataIndex: 'code',
          key: 'code'
        }
      ],
      queryParams: {
        query: [
          {
            field: "code",
            value: ""
          },
          {
            field: "name",
            value: ""
          },
          {
            field: "accessKey",
            value: ""
          },
          {
            field: 'secretKey',
            value: ''
          }
        ],
        filter: [],
        sort: [
          {
            field: "updatedAt",
            value: "DESC"
          }
        ]
      },
      highLightInfo: {
        code: "",
        name: "",
        accessKey: "",
        secretKey: ""
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      stationQueryParams: {
        query: [],
        filter: [],
        sort: [
          {
            field: 'updatedAt',
            value: 'DESC'
          }
        ]
      },
      stationPagination: {
        current: 1,
        total: 0,
        pageSize: 10
      },
      isStationShow: false,
      isLoading: false,
      visible: false,
      title: "新增客户端",
      form: {
        code: "",
        name: "",
        stationScope: [],
        authorities: []
      },
      rules: {
        code: [
          {
            required: true,
            message: this.$t('messages.ecc'),
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('messages.ecn'),
            trigger: "blur"
          }
        ]
      },
      stations: [],
      authoritiesList: [],
      auth: [],
      selectedStations: [],
      sRes: [],
      aRes: [],
      aPagination: {
        current: 1,
        total: 0,
        pageSize: 10
      },
      selectedA: []
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang() {
      this.translate()
    }
  },
  created() {
    this.RESS = {}
    this.translate()
  },
  activated() {
    const a = JSON.parse(sessionStorage.getItem("authorities"));
    if (a?.length) {
      this.auth = a;
    } else {
      this.authorities = this.getAuthorities(this.$route.path);
    }
  },
  mounted() {
    this.getClientLsit();
    this.getAllStations()
    this.getStations();
    this.getAuthorities();
  },
  methods: {
    translate() {
      this.rules = {
        code: [
          {
            required: true,
            message: this.$t('messages.ecc'),
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('messages.ecn'),
            trigger: "blur"
          }
        ]
      }
    },
    handleSort(e, field) {
      let i = e.target;
      let c = "";
      while (i.nodeName !== "SPAN") {
        i = i.parentNode;
      }
      switch (i.classList[1]) {
        case "ASC":
          c = "DESC";
          break;
        case "DESC":
          c = "unset";
          break;
        case "unset":
          c = "ASC";
          break;
        default:
          break;
      }
      i.classList.remove(i.classList[1]);
      i.classList.add(c);
      const f = this.queryParams.sort.findIndex(s => s.field === field);
      if (f < 0) {
        if (c !== "unset") {
          this.queryParams.sort.push({
            field,
            value: c
          });
        }
      } else {
        if (c === "unset") {
          this.queryParams.sort.splice(f, 1);
        } else {
          this.queryParams.sort[f].value = c;
        }
      }
      this.getClientLsit();
    },
    showAModal() {
      this.isAShow = true
      this.selectedA = this.aRes.map(a => a.id + ' ' + a['zh-CN'])
      this.$nextTick(() => {
        const ips = document.querySelectorAll('.aunthorities .ant-input')
        ips.forEach(ip => {
          ip.addEventListener('keyup', ({ key, target }) => {
            // console.log(key, target.value.trim())
            if (key === 'Enter') {
              this.isALoading = true
              this.aPagination.current = 1
              target.value = target.value.trim()
              // target.value.trim() && this.handleSearch()
              this[this.aColumns[+ip.dataset['index']].key] = target.value
            }
            this.searchA()
          })
          ip.addEventListener('blur', ({ target }) => {
            target.value = target.value.trim()
          })
        })
      })
    },
    searchA() {
      let r = []
      for (let i = 0; i < this.totalA.length; i++) {
        const t = this.totalA[i]
        if (t.code.includes(this.code || '') && (t['zh-CN'] || '').includes(this['zh-CN'] || '')) {
          r.push(t)
        }
      }
      this.aPagination.total = r.length
      this.authoritiesList = r.slice((this.aPagination.current - 1) * 10, this.aPagination.current * 10)
      this.isALoading = false
    },
    async getClientLsit() {
      this.isLoading = true;
      try {
        const { data } = await searchClient(
          this.pagination.current,
          this.pagination.pageSize,
          this.queryParams
        );
        this.list = data.records.map(i => {
          i.createdAt = moment(i.createdAt).format("YYYY-MM-DD HH:mm:ss");
          i.updatedAt = moment(i.updatedAt).format("YYYY-MM-DD HH:mm:ss");
          return i;
        });
        this.pagination.total = data.total;
        this.queryParams.query.forEach(q => {
          this.highLightInfo[q.field] = q.value;
        });
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
      }
    },
    async getAuthorities() {
      this.a = {}
      try {
        const { data } = await getAuthoritiesList();
        this.totalA = data
        this.authoritiesList = data.map(d => {
          d.details.forEach(dd => {
            d[dd.locale] = dd.name;
          });
          this.a[d.id] = d['zh-CN']
          return d;
        });
        this.aPagination.total = data.length
      } catch (e) {
        console.log(e);
      }
    },
    hanldeAPageChange(p) {
      this.aPagination.current = p.current
      this.searchA()
    },
    handleTableChange(current) {
      this.pagination.current = current;
      this.getClientLsit();
    },
    handleSearch() {
      this.pagination.current = 1;
      this.getClientLsit();
    },
    clearForm() {
      this.form = {
        code: "",
        name: "",
        stationScope: [],
        authorities: []
      };
      this.sRes = [],
      this.aRes = []
      this.selectedA = []
      this.selectedStations = []
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const form = { ...this.form };
          form.authorities = this.aRes.map(a => ({ id: +a.id }));
          form.stationScope = this.sRes.map(s => s.id)
          try {
            if (form.id) {
              const { message } = await updateClient(form);
              this.$message.success(message);
            } else {
              form.accessKey = "";
              const { message } = await addClient(form);
              this.$message.success(message);
              this.pagination.current = 1;
            }
            this.visible = false;
            this.clearForm();

            this.getClientLsit();
          } catch (e) {
            console.log(e);
          }
        }
      });
    },
    async edit(row) {
      row.loading = true;
      this.list = [...this.list];
      this.title = this.$t('client.editTitle')
      try {
        const { data } = await getClientById(row.id);
        for (let key in this.form) {
          this.form[key] = data[key];
        }
        this.form.id = data.id;
        this.form.stationScope = this.form.stationScope.map(s => s + "");
        this.sRes = this.form.stationScope.map(s => ({ id: s, name: this.totalStations[s] }))
        this.aRes = this.form.authorities.map(aa => ({ id: aa.id, 'zh-CN': this.a[aa.id] }))
      } catch (e) {
        console.log(e);
      } finally {
        row.loading = false;
        this.list = [...this.list];
        this.visible = true;
      }
    },
    async removeClient(id) {
      try {
        const { message } = await deleteClient(id);
        this.$message.success(message);
        this.getClientLsit();
      } catch (e) {
        console.log(e);
      }
    },
    showStationModal() {
      this.isStationShow = true
      this.selectedStations = this.sRes.map(s => {
        return s.id + ' ' + s.name
      })
      this.$nextTick(() => {
        const ips = document.querySelectorAll('.stations .ant-input')
        ips.forEach(ip => {
          ip.addEventListener('keyup', ({ key, target }) => {
            // console.log(key, target.value.trim())
            if (key === 'Enter') {
              target.value = target.value.trim()
              // target.value.trim() && this.handleSearch()
              this.handleSearchStations()
            }
          })
          ip.addEventListener('blur', ({ target }) => {
            target.value = target.value.trim()
          })
        })
      })
    },
    handleSearchStations() {
      this.stationPagination.current = 1
      const ips = document.querySelectorAll('.stations .ant-input')
      this.stationQueryParams.query = []
      ips.forEach(ip => {
        if (ip.value.trim()) {
          this.stationQueryParams.query.push({
            field: this.stationsColumns[+ip.dataset['index']].key,
            value: ip.value
          })
        }
      })
      this.getStations()
    },
    async getAllStations() {
      this.totalStations = {}
      try {
        const { data } = await searchGroupList(
          1,
          100,
          this.stationQueryParams
        )
        if (data.total > 100) {
          const res = await searchGroupList(1, data.total, this.stationQueryParams)
          res.data.records.forEach(r => {
            this.totalStations[r.id] = r.name
          })
        } else {
          data.records.forEach(r => {
            this.totalStations[r.id] = r.name
          })
        }
      } catch(e) {
        console.log(e)
      }
    },
    async getStations() {
      this.isStationsLoading = true
      try {
        let res = await searchGroupList(
          this.stationPagination.current,
          this.stationPagination.pageSize,
          this.stationQueryParams
        );

        this.stations = res.data.records.map(r => {
          r.createdAt = moment(r.createdAt).format("YYYY-MM-DD HH:mm:ss");
          r.updatedAt = moment(r.updatedAt).format("YYYY-MM-DD HH:mm:ss");
          let o = {};
          r.organizations.forEach(or => {
            o[or.name] = or.name;
          });
          o = Object.keys(o).join("，");
          r.organizations = o;
          return r;
        });
        this.stationPagination.total = res.data.total;
      } catch(e) {
        console.log(e);
      } finally {
        this.isStationsLoading = false
      }
    },
    selectStation(rows) {
      this.selectedStations = rows
    },
    selectA(rows) {
      this.selectedA = rows
    },
    confirm() {
      this.sRes = this.selectedStations.map(s => {
        s = s.split(' ')
        return {
          id: s[0],
          name: s[1]
        }
      })
      this.isStationShow = false
    },
    confirmA() {
      this.aRes = this.selectedA.map(s => {
        s = s.split(' ')
        return {
          id: s[0],
          'zh-CN': s[1]
        }
      })
      this.isAShow = false
    },
    handleStationPageChange(pagination) {
      this.stationPagination.current = pagination.current
      this.getStations()
    },
    removeSS(i) {
      this.sRes.splice(i, 1)
    },
    removeAS(i) {
      this.aRes.splice(i, 1)
    }
  }
};
</script>

<style lang="less" scoped>
header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
span {
  position: relative;
}
.anticon-caret-up {
  position: absolute;
  top: -1px;
  right: -8px;
  font-size: 14px;
  color: #ccc;
}
span.ASC .anticon-caret-up {
  color: #1890ff;
}
span.icons {
  position: absolute;
  right: 18px;
}
span.DESC .anticon-caret-down {
  color: #1890ff;
}
.anticon-caret-down {
  position: absolute;
  top: 8px;
  right: -8px;
  font-size: 14px;
  color: #ccc;
}
/deep/ .ant-modal-body {
  padding-bottom: 0;
}
</style>